// Small visual badge that matches the api_models.PredictionStatus enum.
// Lives in its own file because both TestDetailView (the Run rail)
// and future Phase 1C result cards render the same set of states.
import type { Run } from "../api/tests";

const LABELS: Record<Run["status"], string> = {
  pending: "Pending",
  running: "Running",
  complete: "Complete",
  failed: "Failed",
  cancelled: "Cancelled",
};

const COLORS: Record<Run["status"], { bg: string; fg: string }> = {
  // Inline colors keep the chip self-contained; we'll move these into
  // styles.css when CSS Modules land (Phase 6 polish).
  pending: { bg: "#3a3a3a", fg: "#cccccc" },
  running: { bg: "#1e3a5f", fg: "#9ecbff" },
  complete: { bg: "#1f3d1f", fg: "#7ed47e" },
  failed: { bg: "#5a1f1f", fg: "#ff9a9a" },
  cancelled: { bg: "#4a3a1f", fg: "#e4c47a" },
};

export type StatusChipProps = {
  status: Run["status"];
  title?: string;
};

export function StatusChip({ status, title }: StatusChipProps) {
  const { bg, fg } = COLORS[status];
  return (
    <span
      role="status"
      title={title}
      // status-chip--running adds a pulsing dot (styles.css) so an
      // in-flight Run reads as alive, not frozen.
      className={status === "running" ? "status-chip status-chip--running" : "status-chip"}
      style={{
        display: "inline-block",
        padding: "1px 8px",
        borderRadius: "10px",
        fontSize: "11px",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        backgroundColor: bg,
        color: fg,
      }}
      data-status={status}
    >
      {LABELS[status]}
    </span>
  );
}
